var _rect, _rect2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.61536,
    y: 1,
    width: 6.92308,
    height: 13.8462,
    rx: 2,
    fill: "#FFF",
    stroke: "#C8C8C8",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.30774,
    y: 4.46143,
    width: 11.5385,
    height: 11.5385,
    rx: 2,
    fill: "#FFF",
    stroke: "#C8C8C8",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4.61548,
    x2: 15.1538,
    y2: 4.61548,
    stroke: "#C8C8C8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 8,
    x2: 6,
    y2: 11,
    stroke: "#C8C8C8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 8,
    x2: 9,
    y2: 11,
    stroke: "#C8C8C8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTrash);
export default __webpack_public_path__ + "static/media/small_trash.93facde455ecda8f36bd33cb4bc470b1.svg";
export { ForwardRef as ReactComponent };